import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlogRoutingModule } from './blog-routing.module';
// import { HomeModule } from '../home/home.module';
import { SharedModule } from '../shared/shared.module';
import { BlogComponent } from './blog.component';
import { BlogEntryComponent } from './blog-entry/blog-entry.component';
import { BlogCategoryComponent } from './blog-category/blog-category.component';
import { BlogTagComponent } from './blog-tag/blog-tag.component';

// Shared subcomponents
// import { NavComponent } from './../shared/nav/nav.component';
import { MastheadComponent } from './shared/components/masthead/masthead.component';
import { SearchFilterComponent } from './shared/components/search-filter/search-filter.component';
import { BlogEntriesComponent } from './shared/components/blog-entries/blog-entries.component';
import { EntryCardComponent } from './shared/components/entry-card/entry-card.component';
// import { EntryHeaderComponent } from './shared/components/entry-header/entry-header.component';
// import { EntryContentComponent } from './shared/components/entry-content/entry-content.component';
import { RelatedEntriesComponent } from './shared/components/related-entries/related-entries.component';
import { NewsletterBannerComponent } from './shared/components/newsletter-banner/newsletter-banner.component';
import { BreadcrumbsComponent } from './shared/components/breadcrumbs/breadcrumbs.component';
// import { ContactFormComponent } from '../shared/contact-form/contact-form.component';
// import { FooterComponent } from './../shared/footer/footer.component';

@NgModule({
  declarations: [
    BlogComponent,
    // NavComponent,
    BlogEntryComponent,
    BlogCategoryComponent,
    BlogTagComponent,
    MastheadComponent,
    SearchFilterComponent,
    BlogEntriesComponent,
    EntryCardComponent,
    // EntryHeaderComponent,
    // EntryContentComponent,
    RelatedEntriesComponent,
    NewsletterBannerComponent,
    BreadcrumbsComponent,
    // ContactFormComponent,
    // FooterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BlogRoutingModule,
    // HomeModule,
    SharedModule
  ],
	exports: [
		BlogRoutingModule
	]
})

export class BlogModule { }